import { Theme } from '@mui/material';

export const sxStyles = {
  footer: (theme: Theme) => ({
    padding: '1.5rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
};
